import React from 'react';
import { Box, Typography } from '../../../design-system';
import { colors } from '../../../design-system/colors';
import { ClockIcon, SortIcon } from '../../../design-system/icons';
import { TableHeaderColumn } from '../constants/uploadsTableHeader';

interface LibraryTableHeaderProps {
  columns: TableHeaderColumn[];
  sortField: string | null;
  sortDirection: 'asc' | 'desc' | null;
  onSort: (field: string) => void;
}

/**
 * Generic table header for library tables (Uploads, Exports)
 */
const LibraryTableHeader: React.FC<LibraryTableHeaderProps> = ({
  columns,
  sortField,
  sortDirection,
  onSort,
}): JSX.Element => (
  <tr>
    {columns.map((column) => (
      <th
        key={column.field}
        style={{
          width: column.field === 'clip' ? 'var(--cc-clipw, 138px)' : (typeof column.width === 'number' ? `${column.width}px` : column.width),
          padding: column.padding ?? '12px 24px',
          textAlign: column.align,
          borderBottom: `1px solid ${colors.table.headerBorder}`,
          cursor: column.sort ? 'pointer' : 'default',
          fontFamily: 'Outfit, sans-serif',
          fontSize: '14px',
          fontWeight: 600,
          color: colors.neutral.white,
          backgroundColor: 'transparent',
          verticalAlign: 'middle',
        }}
        onClick={() => column.sort && onSort(column.field)}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: column.iconKey === 'clock' ? '6px' : '4px',
          }}
        >
          {column.iconKey === 'clock' ? (
            <ClockIcon size={18} color={colors.neutral.white} aria-label="Duration" />
          ) : (
            <Typography
              variant="body"
              sx={{
                fontFamily: 'Outfit, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: colors.neutral.white,
                lineHeight: '20px',
              }}
            >
              {column.title}
            </Typography>
          )}
          {column.sort && (
            <SortIcon
              size={18}
              color={colors.text[700]}
              circleColor={colors.background[700]}
              aria-label={
                sortField === column.field
                  ? `Sorted ${sortDirection === 'asc' ? 'ascending' : 'descending'}`
                  : 'Sort'
              }
            />
          )}
        </Box>
      </th>
    ))}
  </tr>
);

export default LibraryTableHeader;
